;(function () {
  //Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById(
      'view-transition-render-blocker'
    )
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove()
  }

  const idleCallback =
    typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout

  /**
   * @param {ViewTransition} viewTransition
   * @param {string} type
   */
  function setViewTransitionType(viewTransition, type) {
    if (!supportsViewTransitionTypes(viewTransition)) return false

    viewTransition.types.clear()
    viewTransition.types.add(type)

    return true
  }

  function clearCustomTransitionState() {
    sessionStorage.removeItem('custom-transition-type')
    document
      .querySelectorAll('[data-view-transition-type]')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type')
      })
  }

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return

    const { viewTransition } = event

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ;['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition()
        },
        { once: true }
      )
    })

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll(
        '[data-view-transition-type]:not([data-view-transition-triggered])'
      )
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type')
      })

    const transitionTriggered = document.querySelector(
      '[data-view-transition-triggered]'
    )
    const transitionType = transitionTriggered?.getAttribute(
      'data-view-transition-type'
    )

    if (transitionType) {
      if (setViewTransitionType(viewTransition, transitionType)) {
        sessionStorage.setItem('custom-transition-type', transitionType)
      } else {
        sessionStorage.removeItem('custom-transition-type')
      }
    } else {
      setViewTransitionType(viewTransition, 'page-navigation')
      sessionStorage.removeItem('custom-transition-type')
    }
  })

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return

    const { viewTransition } = event
    const customTransitionType = sessionStorage.getItem(
      'custom-transition-type'
    )

    if (customTransitionType) {
      if (!setViewTransitionType(viewTransition, customTransitionType)) {
        idleCallback(clearCustomTransitionState)
        return
      }

      await viewTransition.finished

      setViewTransitionType(viewTransition, 'page-navigation')

      idleCallback(() => {
        clearCustomTransitionState()
      })
    } else {
      setViewTransitionType(viewTransition, 'page-navigation')
    }
  })

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return (
      typeof ViewTransition === 'function' &&
      'viewTransition' in event &&
      event.viewTransition instanceof ViewTransition
    )
  }

  /**
   * @param {ViewTransition} viewTransition
   * @returns {boolean}
   */
  function supportsViewTransitionTypes(viewTransition) {
    return (
      viewTransition.types &&
      typeof viewTransition.types.add === 'function' &&
      typeof viewTransition.types.clear === 'function'
    )
  }
})()
